import { Action, combineReducers } from '@ngrx/store';

import { scannerReducer } from './barcode-reader';
import { scanToBasketReducer } from './basket/scan-to-basket.reducer';
import { SCANNER_FEATURE_KEY, SCANN_TO_BASKET_FEATURE_KEY } from './constants';
import { State } from './models';

export const SCAN_FEATURE_KEY = 'scan';

export function reducers(state: State | undefined, action: Action) {
  return combineReducers({
    [SCANNER_FEATURE_KEY]: scannerReducer,
    [SCANN_TO_BASKET_FEATURE_KEY]: scanToBasketReducer,
  })(state, action);
}
